export const isOnSearchPage = (pathname: string): boolean => {
  return '/baumaschinen-mieten/[[...categories]]' === pathname;
};
